import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';

const ModificationConfirmationDialog = ({
  onConfirm,
  onCancel,
  isOpen,
  setIsOpen,
  title,
}: {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
  title: string;
}) => {
  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  const handleCancel = () => {
    onCancel();
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <Typography>
            Everyone will be able to see your changes. Unlike chats, prompts are public.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModificationConfirmationDialog;
